export default "__VITE_ASSET__BWES1249__"